import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const WhatYouGetSection = () => {
  const items = [{
    title: "Guía Maestra 'El Sistema Blindado'",
    desc: 'El manual paso a paso desde el diagnóstico hasta el borrado total (PDF).'
  }, {
    title: 'El Kit de 3 Cartas Maestras de Disputa',
    desc: 'Listas para que solo pongas tu nombre, imprimas y envíes.'
  }, {
    title: "Guion 'Cuelga y Negocia'",
    desc: 'Lo que debes decir palabra por palabra para que los cobradores dejen de llamarte hoy mismo.'
  }, {
    title: 'Estrategia Liquidación 20%',
    desc: "Cómo negociar deudas viejas por una fracción de su valor real y obtener el documento 'Pay for Delete'."
  }, {
    title: 'Checklist de Auditoría de Identidad',
    desc: 'El truco para subir puntos eliminando direcciones y nombres viejos de tu perfil.'
  }];
  return <SectionWrapper bg="bg-navy-900" data-id="element-121">
      <h2 className="font-serif text-3xl md:text-5xl font-bold text-center mb-16 text-white" data-id="element-122">
        Lo que <span className="text-gold-500" data-id="element-123">obtienes hoy</span>
      </h2>

      <div className="space-y-6 mb-16" data-id="element-124">
        {items.map((item, index) => <div key={index} className="flex items-start gap-5 bg-navy-800 p-6 md:p-8 rounded-2xl border border-navy-800 hover:border-gold-500/30 transition-all duration-300 shadow-lg" data-id="element-125">
            <div className="bg-navy-900 p-3 rounded-full flex-shrink-0 mt-1 shadow-inner border border-navy-800" data-id="element-126">
              <ShieldCheck className="w-6 h-6 text-gold-500" data-id="element-127" />
            </div>
            <div data-id="element-128">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-129">
                {item.title}
              </h3>
              <p className="text-gray-300 text-lg" data-id="element-130">{item.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="flex justify-center" data-id="element-131">
        <CTAButton data-id="element-132" />
      </div>
    </SectionWrapper>;
};